module.exports = __webpack_public_path__ + "img/shahr.0ed2591.png";